import React from 'react'
import './instapagostStyle.css';
function OrderClientData({numOrder, customerInfo}) {
  return (
    <div>
        <div className="container px-0" style={{maxWidth:1280}}>
            <h4 className='text-center mb-4 title-order-data' style={{color:'#424242'}}>Datos de la orden {numOrder}</h4>
            <div className="row justify-content-between" style={{rowGap:13}}>
                <div className="input-group col-12 col-md-5 px-0">
                    <span className="input-group-text text-white" style={{backgroundColor:'#014788'}}>Numero de orden</span>
                    <input type="text" className="form-control" disabled value={numOrder}/>
                </div>
                <div className="input-group col-12 col-md-5 px-0">
                    <span className="input-group-text text-white" style={{backgroundColor:'#014788'}}>Nombre y Apellido</span>
                    <input type="text" className="form-control" disabled value={customerInfo.name || 'Sin asignar'}/>
                </div>
                <div className="input-group col-12 col-md-5 px-0">
                    <span className="input-group-text text-white" style={{backgroundColor:'#014788'}}>{customerInfo.l10n_latam_identification_type_id[1]}</span>
                    <input type="text" className="form-control" disabled value={customerInfo.vat || 'Sin asignar'}/>
                </div>
                <div className="input-group col-12 col-md-5 px-0">
                    <span className="input-group-text text-white" style={{backgroundColor:'#014788'}}>Telefono</span>
                    <input type="text" className="form-control" disabled value={customerInfo.phone || 'Sin asignar'}/>
                </div>
                <div className="input-group col-12 col-md-5 px-0">
                    <span className="input-group-text text-white" style={{backgroundColor:'#014788'}}>Estado</span>
                    <input type="text" className="form-control" disabled value={customerInfo.state_id[1] || 'Sin asignar'}/>
                </div>
                <div className="input-group col-12 col-md-5 px-0">
                        <span className="input-group-text text-white" style={{backgroundColor:'#014788'}}>Dirección</span>
                    <input type="text" className="form-control" disabled value={customerInfo.street || 'Sin asignar'}/>
                </div>
                <div className="col-12 col-lg-6"></div>
            </div>
        </div>
  </div>
  )
}

export default OrderClientData